export default __webpack_public_path__ + "static/media/M45.c9d92e86.svg";